<template>
    <div class="container mx-auto h-screen">
        <!-- logo -->
        <div class="flex flex-col items-center justify-center mt-32">
            <img class="w-64" src="../assets/logo-megaluzz.png" alt="Megaluzz Logo">
        </div>

        <div class="flex justify-center mt-2">
            <h1 class="text-gray-600 font-bold text-xl sm:text-2xl">Questionário Respondido, Obrigado!</h1>
        </div>
    </div>
</template>